var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedGreyArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.884 10.884a1.25 1.25 0 000-1.768L2.929 1.161A1.25 1.25 0 101.16 2.93L8.232 10l-7.07 7.071a1.25 1.25 0 101.767 1.768l7.955-7.955zM9 11.25h1v-2.5H9v2.5z",
    fill: "#8E8E8E"
  })));
}
export default SvgLedGreyArrow;